<template>
  <d-container class="h-100">
    <d-row class="h-100 align-items-center">
      <d-col class="main-content p-0" tag="main" sm="12">
        <div class="new-pass-form__title">Digite sua nova senha.</div>

        <p class="new-pass-form__label">Senha atual</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--user input--no-icon"
          type="text"
          placeholder="Senha"
          v-model="form.oldPassword"
          required
        >

        <p class="new-pass-form__label">Nova senha</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--pass input--no-icon"
          type="password"
          placeholder="Senha"
          v-model="form.newPassword"
          required
        >

        <p class="new-pass-form__label">Confirmar nova senha</p>

        <input
          @keydown.enter="sendNewPass()"
          class="input input--pass input--no-icon"
          type="password"
          placeholder="Senha"
          v-model="form.confirmNewPassword"
          ref="confirmPass"
          required
        >

        <div class="new-pass-form__control control">
          <div class="control__error">
            <span v-if="error">{{ error }}</span>
            <md-spinner v-if="loading" md-indeterminate></md-spinner>
          </div>

          <div class="control__send">
            <div
              @click="sendNewPass()"
              class="btn btn--small btn--swidth"
            >
              Enviar
            </div>
          </div>
        </div>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
export default {
  name: 'new-password',
  data() {
    return {
      form: {
        oldPassword: null,
        newPassword: null,
        confirmNewPassword: null,
      },
      loading: false,
      error: false,
    };
  },
  methods: {
    sendNewPass() {
      this.error = false;
      this.loading = true;

      if (this.form.newPassword !== this.form.confirmNewPassword) {
        this.error = 'As senhas não conferem.';
        this.loading = false;
      }
    },
  },
};
</script>
